import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { ScrollTo } from '../actions';

import {
  Collapse,
  Navbar,
  Container,
  NavbarToggler,
  Nav,
  NavItem
} from 'reactstrap';
import './NavbarWeb.css';

import logoGrande from '../images/logo_gonemadstudios_white.png';
import logoTextoGrande from '../images/logo_gonemadstudios_name_white.png';

class NavbarWeb extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      scrollY: 0,
      showBarThreshold: 60
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    this.setState({ scrollY: window.scrollY });
  }

  render() {
    return (
      <Navbar dark expand="lg" id="mainNav" fixed="top" className={(this.state.scrollY > this.state.showBarThreshold || !this.props.pageHaveHeader) ? "navbar-shrink" : ""}>
        <Container>
          <Link to="/" className="navbar-brand js-scroll-trigger" onClick={this.props.scrollToHeader ? this.props.scrollToHeader : () => this.props.SetScrollTo("")}>
            <img width="60vw" src={logoGrande} className="navbar-logo" alt=""/>
            <img width="100vw" src={logoTextoGrande} alt="Gone Mad Studios"/>
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} id="navbarResponsive" navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <Link to="/" className="nav-link" onClick={this.props.scrollToAbout ? this.props.scrollToAbout : () => this.props.SetScrollTo("about")}><Translate id="navbar.about">El estudio</Translate></Link>
              </NavItem>
              <NavItem>
                <Link to="/" className="nav-link" onClick={this.props.scrollToServices ? this.props.scrollToServices : () => this.props.SetScrollTo("services")}><Translate id="navbar.services">Servicios</Translate></Link>
              </NavItem>
              <NavItem>
                <Link to="/" className="nav-link" onClick={this.props.scrollToProjects ? this.props.scrollToProjects : () => this.props.SetScrollTo("projects")}><Translate id="navbar.projects">Proyectos</Translate></Link>
              </NavItem>
              <NavItem>
                <Link to="/" className="nav-link" onClick={this.props.scrollToGames ? this.props.scrollToGames : () => this.props.SetScrollTo("games")}><Translate id="navbar.games">Gone Mad Games</Translate></Link>
              </NavItem>
              <NavItem>
                <a className="nav-link" href="https://www.nemmusmusic.com/" target="_blank" rel="noopener noreferrer"><Translate id="navbar.nemmus_music">Nemmus Music</Translate></a>
              </NavItem>
              <NavItem>
                <Link to="/" className="nav-link" onClick={this.props.scrollToContact ? this.props.scrollToContact : () => this.props.SetScrollTo("contact")}><Translate id="navbar.contact">Contacto</Translate></Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetScrollTo: (scrollTo) => {dispatch(ScrollTo(scrollTo))}
  }
}

function mapStateToProps(state) {
  return {
    pageHaveHeader: state.ChangeNavbar.haveHeader,
    scrollToHeader: state.ScrollToHeader.scrollToHeader,
    scrollToAbout: state.ScrollToAbout.scrollToAbout,
    scrollToPartners: state.ScrollToPartners.scrollToPartners,
    scrollToServices: state.ScrollToServices.scrollToServices,
    scrollToProjects: state.ScrollToProjects.scrollToProjects,
    scrollToGames: state.ScrollToGames.scrollToGames,
    scrollToContact: state.ScrollToContact.scrollToContact
  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(NavbarWeb);
